export var createDate = str => {
  if (str && !/^\d{4}-\d{2}-\d{2}$/.test(str)) {
    throw new Error('Use YYYY-MM-DD');
  }

  if (str) {
    // eslint-disable-next-line no-restricted-syntax
    return new Date("".concat(str, "T12:00:00.000Z"));
  } // eslint-disable-next-line no-restricted-syntax


  var date = new Date();
  date.setHours(12, 0, 0, 0);
  return date;
}; // XXX hack to get around payment intent expects the dates to be YYYY-MM-DD and not a standard ISO date string
// https://meliorisk.atlassian.net/browse/ME-19758

export var convertDateToStringRepresentation = date => date === null || date === void 0 ? void 0 : date.toISOString().substring(0, 10);
//# sourceMappingURL=date-utils.js.map